/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  FilterResponse,
  GetV6NotificationStatusByMethodTypeAndResultIdParams,
  NotificationFilter,
  NotificationHistoryResponse,
  NotificationStatusResponse,
  PostV6NotificationHistoryListParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Notification 과거 이력 필터
 */
export const getV6NotificationFilters = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<FilterResponse>(
    { url: `/api/v6/notification/filters`, method: 'GET', signal },
    options,
  );
};

export const getGetV6NotificationFiltersQueryKey = () => {
  return ['api', 'v6', 'notification', 'filters'] as const;
};

export const getGetV6NotificationFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV6NotificationFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV6NotificationFilters>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV6NotificationFiltersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV6NotificationFilters>>> = ({
    signal,
  }) => getV6NotificationFilters(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV6NotificationFilters>>,
    TError,
    TData
  >;
};

export type GetV6NotificationFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV6NotificationFilters>>
>;
export type GetV6NotificationFiltersQueryError = ErrorType<unknown>;

/**
 * @summary Notification 과거 이력 필터
 */

export function useGetV6NotificationFilters<
  TData = Awaited<ReturnType<typeof getV6NotificationFilters>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV6NotificationFilters>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV6NotificationFiltersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Notification 과거 이력 조회
 */
export const postV6NotificationHistoryList = (
  notificationFilter: MaybeRef<NotificationFilter>,
  params?: MaybeRef<PostV6NotificationHistoryListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  notificationFilter = unref(notificationFilter);
  params = unref(params);

  return customAxiosInstance<NotificationHistoryResponse>(
    {
      url: `/api/v6/notification/history-list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: notificationFilter,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV6NotificationHistoryListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6NotificationHistoryList>>,
    TError,
    { data: BodyType<NotificationFilter>; params?: PostV6NotificationHistoryListParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6NotificationHistoryList>>,
  TError,
  { data: BodyType<NotificationFilter>; params?: PostV6NotificationHistoryListParams },
  TContext
> => {
  const mutationKey = ['postV6NotificationHistoryList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6NotificationHistoryList>>,
    { data: BodyType<NotificationFilter>; params?: PostV6NotificationHistoryListParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV6NotificationHistoryList(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6NotificationHistoryListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV6NotificationHistoryList>>
>;
export type PostV6NotificationHistoryListMutationBody = BodyType<NotificationFilter>;
export type PostV6NotificationHistoryListMutationError = ErrorType<unknown>;

/**
 * @summary Notification 과거 이력 조회
 */
export const usePostV6NotificationHistoryList = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6NotificationHistoryList>>,
      TError,
      { data: BodyType<NotificationFilter>; params?: PostV6NotificationHistoryListParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6NotificationHistoryList>>,
  TError,
  { data: BodyType<NotificationFilter>; params?: PostV6NotificationHistoryListParams },
  TContext
> => {
  const mutationOptions = getPostV6NotificationHistoryListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Notification Status 상세조회
 */
export const getV6NotificationStatusByMethodTypeAndResultId = (
  methodType: MaybeRef<'email' | 'kakaoTalk' | 'onSite' | 'slack' | 'sms' | 'telegram' | 'webhook'>,
  resultId: MaybeRef<string>,
  params?: MaybeRef<GetV6NotificationStatusByMethodTypeAndResultIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  methodType = unref(methodType);
  resultId = unref(resultId);
  params = unref(params);

  return customAxiosInstance<NotificationStatusResponse>(
    {
      url: `/api/v6/notification/status/${methodType}/${resultId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV6NotificationStatusByMethodTypeAndResultIdQueryKey = (
  methodType?: MaybeRef<
    'email' | 'kakaoTalk' | 'onSite' | 'slack' | 'sms' | 'telegram' | 'webhook'
  >,
  resultId?: MaybeRef<string>,
  params?: MaybeRef<GetV6NotificationStatusByMethodTypeAndResultIdParams>,
) => {
  return [
    'api',
    'v6',
    'notification',
    'status',
    methodType,
    resultId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV6NotificationStatusByMethodTypeAndResultIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV6NotificationStatusByMethodTypeAndResultId>>,
  TError = ErrorType<unknown>,
>(
  methodType: MaybeRef<'email' | 'kakaoTalk' | 'onSite' | 'slack' | 'sms' | 'telegram' | 'webhook'>,
  resultId: MaybeRef<string>,
  params?: MaybeRef<GetV6NotificationStatusByMethodTypeAndResultIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV6NotificationStatusByMethodTypeAndResultId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV6NotificationStatusByMethodTypeAndResultIdQueryKey(
    methodType,
    resultId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV6NotificationStatusByMethodTypeAndResultId>>
  > = ({ signal }) =>
    getV6NotificationStatusByMethodTypeAndResultId(
      methodType,
      resultId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(methodType) && unref(resultId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV6NotificationStatusByMethodTypeAndResultId>>,
    TError,
    TData
  >;
};

export type GetV6NotificationStatusByMethodTypeAndResultIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV6NotificationStatusByMethodTypeAndResultId>>
>;
export type GetV6NotificationStatusByMethodTypeAndResultIdQueryError = ErrorType<unknown>;

/**
 * @summary Notification Status 상세조회
 */

export function useGetV6NotificationStatusByMethodTypeAndResultId<
  TData = Awaited<ReturnType<typeof getV6NotificationStatusByMethodTypeAndResultId>>,
  TError = ErrorType<unknown>,
>(
  methodType: MaybeRef<'email' | 'kakaoTalk' | 'onSite' | 'slack' | 'sms' | 'telegram' | 'webhook'>,
  resultId: MaybeRef<string>,
  params?: MaybeRef<GetV6NotificationStatusByMethodTypeAndResultIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV6NotificationStatusByMethodTypeAndResultId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV6NotificationStatusByMethodTypeAndResultIdQueryOptions(
    methodType,
    resultId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
